// Note: only #imports is a valid source here, otherwise the app will never finish loading!!!
import type { AppCountryConfig, TransactionalEmailConfig } from './index'
import { defineAppConfig } from '#imports'

const deInvoiceRequestProd: TransactionalEmailConfig = {
  templateName: 'customer-invoice-request-prod',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'mail@heiland.com',
  bccEmail: 'orders+invoice@heiland.com',
}

const deOrderStatusRequestProd: TransactionalEmailConfig = {
  templateName: 'customer-order-status-request-prod',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'orders@heiland.com',
  bccEmail: 'orders+orderstatus@heiland.com',
}

const deInvoiceRequestStaging: TransactionalEmailConfig = {
  templateName: 'customer-invoice-request-staging',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'mail+staging@heiland.com',
  bccEmail: 'orders+invoice@heiland.com',
}

const deOrderStatusRequestStaging: TransactionalEmailConfig = {
  templateName: 'customer-order-status-request-staging',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'orders+staging@heiland.com',
  bccEmail: 'orders+orderstatus@heiland.com',
}

const deOrderChangeProd: TransactionalEmailConfig = {
  templateName: 'order-change-prod',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'orders@heiland.com',
  bccEmail: 'orders@heiland.com',
}

const deOrderChangeStaging: TransactionalEmailConfig = {
  templateName: 'order-change-staging',
  senderEmailLabel: 'Heiland GmbH',
  senderEmailValue: 'mail+staging@heiland.com',
  bccEmail: 'mail+staging@heiland.com',
}

const frOrderChangeProd: TransactionalEmailConfig = {
  templateName: 'order-change-prod_fr',
  senderEmailLabel: 'vetmazing.com',
  senderEmailValue: 'orders@vetmazing.com',
  bccEmail: 'orders@vetmazing.com',
}

const frInvoiceRequestProd: TransactionalEmailConfig = {
  templateName: 'customer-invoice-request-prod_fr',
  senderEmailLabel: 'vetmazing.com',
  senderEmailValue: 'mail@vetmazing.com',
  bccEmail: 'orders+invoice@vetmazing.com',
}

const frOrderStatusRequestProd: TransactionalEmailConfig = {
  templateName: 'customer-order-status-request-prod_fr',
  senderEmailLabel: 'vetmazing.com',
  senderEmailValue: 'orders@vetmazing.com',
  bccEmail: 'orders+orderstatus@vetmazing.com',
}

export default defineAppConfig({
  countryConfig: {
    de: {
      envOverwrites: {
        staging: {
          sns: {
            topics: {
              new_registration: 'arn:aws:sns:eu-central-1:177011103114:staging-euc1-infra-shared-webshop-new-registration-topic',
              profile_updated: 'arn:aws:sns:eu-central-1:177011103114:staging-euc1-infra-shared-webshop-profile-updated-topic',
            },
          },
          shopUrl: 'https://shop-staging.heiland.com/de',
          transactionalEmails: {
            invoiceRequest: deInvoiceRequestStaging,
            orderStatusRequest: deOrderStatusRequestStaging,
            orderChange: deOrderChangeStaging,
          },
        },
      },
      emailBaseInfo: {
        label: 'heiland.com',
        value: 'mail@heiland.com',
        replyLabel: 'heiland.com',
        replyValue: 'mail@heiland.com',
        bcc: 'mail@heiland.com',
        phone: '040 40 119 221',
      },
      defaultCustomerReference: 'Bitte_Heiland_melden',
      sns: {
        topics: {
          new_registration: 'arn:aws:sns:eu-central-1:177011103114:prod-euc1-infra-shared-webshop-new-registration-topic',
          profile_updated: 'arn:aws:sns:eu-central-1:177011103114:prod-euc1-infra-shared-webshop-profile-updated-topic',
        },
      },
      shopUrl: 'https://shop.heiland.com/de',
      transactionalEmails: {
        invoiceRequest: deInvoiceRequestProd,
        orderStatusRequest: deOrderStatusRequestProd,
        orderChange: deOrderChangeProd,
      },
      martailer: { language: 'de', batchSize: 100, audienceUsersBatchSize: 5000 },
    },
    fr: {
      emailBaseInfo: {
        label: 'vetmazing.com',
        value: 'mail@vetmazing.com',
        replyLabel: 'vetmazing.com',
        replyValue: 'mail@vetmazing.com',
        bcc: 'mail@vetmazing.com',
        phone: '+33 646 806 913',
      },
      defaultCustomerReference: 'Bitte_Heiland_melden',
      sns: {
        topics: {
          new_registration: 'arn:aws:sns:eu-west-3:177011103114:prod-euw3-infra-shared-webshop-new-registration-topic',
          profile_updated: 'arn:aws:sns:eu-west-3:177011103114:prod-euw3-infra-shared-webshop-profile-updated-topic',
        },
      },
      shopUrl: 'https://shop.vetmazing.com/fr',
      transactionalEmails: {
        invoiceRequest: frInvoiceRequestProd,
        orderStatusRequest: frOrderStatusRequestProd,
        orderChange: frOrderChangeProd,
      },
      martailer: { language: 'fr', batchSize: 100, audienceUsersBatchSize: 5000 },
    },
  } satisfies AppCountryConfig,
})
